export default ({id, tileColor}) => {
	return `
		<?xml version="1.0" encoding="utf-8"?>
		<browserconfig>
			<msapplication>
				<tile>
					<square70x70logo src="/env/${id}/icons/icon-70.png"/>
					<square150x150logo src="/env/${id}/icons/icon-150.png"/>
					<square310x310logo src="/env/${id}/icons/icon-310.png"/>
					<TileColor>${tileColor}</TileColor>
				</tile>
			</msapplication>
		</browserconfig>

	`;
}
